<p-toast></p-toast>

<div class="request-add page-container">
  @if (isSaving() || isCanceling()) {
    <div class="blocking-overlay">
      <div class="loading-spinner">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #3388ff;"></i>
        <p class="loading-text">{{ (isSaving() ? 'SAVING_REQUEST' : 'CANCELING_REQUEST') | translate }}</p>
      </div>
    </div>
  }

  <app-back-button
    [title]="'Request'"
    parentRoute="/crop-monitoring/requests"
  ></app-back-button>

  @if (isLoading()) {
    <app-loading [loading]="isLoading()">

    </app-loading>
  } @else {

    <div class="request-add__form">
      @if (requestType() === 'ground') {
        <app-ground-survey
          [(bid)]="bid"
          (cancel)="showConfirmCancelModal = true"
          (save)="saveRequest($event)"
          [isSaving]="isSaving"
          [isCanceling]="isCanceling"

        ></app-ground-survey>
      } @else {
        <app-uav
          [(bid)]="bid"
          (cancel)="showConfirmCancelModal = true"
          (save)="saveRequest($event)"
        ></app-uav>
      }

    </div>
  }
</div>


<app-dialog
  [(visible)]="showConfirmCancelModal"
  header="Confirm"
  width="450px"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
>
  <div style="display: flex; align-items: center;">

    <span>{{ 'requestConfirmCancel' | translate }}</span>
  </div>
  <ng-template #footer>
    <button pButton type="button" [label]="'No' | translate" class="p-button-text p-button-cancel-btn"
            (click)="showConfirmCancelModal = false"></button>
    <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger"
            (click)="showConfirmCancelModal = false ; cancelBid()"></button>
  </ng-template>
</app-dialog>
